import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M9 18a2.498 2.498 0 0 0 2.289-1.5H6.711A2.498 2.498 0 0 0 9 18zm8.293-4.707L15 11V6.251C15 2.966 12.468.101 9.185.002A6.002 6.002 0 0 0 3 6v5L.707 13.293C.077 13.923.523 15 1.414 15h15.172c.891 0 1.337-1.077.707-1.707z" />
  </svg>
);

export default SvgComponent;
